export default "__VITE_ASSET__CBr0MGWL__"